import React, { useContext }from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { Badge, TouchableRipple, useTheme } from 'react-native-paper';
import { TabBar } from 'react-native-tab-view';

import { CaseContext } from '~context/caseContext';
export const CaseTabBar = (props) => {
	const theme = useTheme();
	const _case = useContext(CaseContext);
	const tabBarHeight = Platform.OS === 'web' ? 75 : 65;
	const badgeRightMargin = Platform.OS === 'web' ? 50 : 15;
	const jumpTo = props.jumpTo;
	const styles = StyleSheet.create({
		tabBar: { 
			backgroundColor: theme.colors.surface, 
			height: tabBarHeight
		},
		indicator: { backgroundColor: theme.colors.primary },
		badge: { 
			position: 'absolute',
			top: 5,
			right: badgeRightMargin
		},
		tabBarItem:{
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			height: '100%'
		}
	});
	return (
		<TabBar 
			{...props}
			activeColor={theme.colors.primary}
			inactiveColor={theme.colors.text}
			indicatorStyle={styles.indicator}
			style={styles.tabBar}
			renderTabBarItem={(props) => {
				const isFocused =  props.navigationState.routes[props.navigationState.index].key === props.route.key;
				const Icon = props.route.icon;
				let BadgeStyled;
				switch(props.route.key){
				case 'forms':					
					BadgeStyled = <Badge visible={_case.formsBadge}  size={12} style={styles.badge} />;
					break;
				case 'messages':
					BadgeStyled = <Badge visible={_case.messagesBadge}  size={12} style={styles.badge} />;
					break;
				case 'files':
					BadgeStyled = <Badge visible={_case.filesBadge}  size={12} style={styles.badge} />;
					break;
				case 'treatment':
					BadgeStyled = <Badge visible={_case.treatmentsBadge}  size={12} style={styles.badge} />;
					break;
				}
				return <TouchableRipple  onPress={() => jumpTo(props.route.key)} style={{ height: '100%' }}>
					<View style={[ styles.tabBarItem, { width: props.defaultTabWidth }]}>
						<Icon fill={isFocused ? props.activeColor : props.inactiveColor} />
						{BadgeStyled}
					</View>
				</TouchableRipple>;
			}}		
		/>
	);
};

